import { render, staticRenderFns } from "./LanguagesList.vue?vue&type=template&id=3ddd566e&"
import script from "./LanguagesList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LanguagesList.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ddd566e')) {
      api.createRecord('3ddd566e', component.options)
    } else {
      api.reload('3ddd566e', component.options)
    }
    module.hot.accept("./LanguagesList.vue?vue&type=template&id=3ddd566e&", function () {
      api.rerender('3ddd566e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/LanguagesList/LanguagesList.vue"
export default component.exports